import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "font-semibold text-xl text-black-lp-100 border-b border-gray-lp-1300 w-full py-2.5 px-8 font-montserrat flex items-center justify-between" }
const _hoisted_2 = {
  "data-testid": "modal-booking-reverse-journey-v4-container",
  class: "flex flex-row items-start gap-3 p-3 bg-gray-lp-1200 font-montserrat h-full",
  style: {"width":"calc(80vw / var(--viewport-scale)) !important"},
  tabindex: "0"
}
const _hoisted_3 = {
  id: "modal-booking-reverse-journey-v4-form-main-column",
  "data-testid": "modal-booking-reverse-journey-v4-form-main-column",
  class: "flex-1 min-w-0 flex flex-col gap-y-2 pb-3"
}
const _hoisted_4 = {
  class: "font-semibold text-black-lp-300 flex flex-row items-center",
  style: {"gap":"8px"}
}
const _hoisted_5 = { class: "flex items-stretch gap-x-3" }
const _hoisted_6 = {
  id: "modal-booking-reverse-journey-v4-section-sender",
  class: "flex-shrink-0 min-w-0",
  style: {"flex-basis":"38%"}
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", {
  class: "flex flex-col items-center justify-between py-1.5 flex-none",
  style: {"gap":"4px"}
}, [
  /*#__PURE__*/_createVNode("span", { class: "flex-shrink-0 w-3 h-3 rounded-full bg-gray-lp-1300" }),
  /*#__PURE__*/_createVNode("div", { class: "flex-1 border-l-2 border-dashed border-gray-lp-1300" }),
  /*#__PURE__*/_createVNode("span", { class: "flex-shrink-0 w-3 h-3 rounded-full bg-gray-lp-1300" })
], -1)
const _hoisted_8 = {
  id: "modal-booking-reverse-journey-v4-section-receiver",
  class: "flex-1 min-w-0"
}
const _hoisted_9 = {
  id: "booking-v4-section-product-type",
  class: "mb-2"
}
const _hoisted_10 = {
  id: "modal-booking-reverse-journey-v4-sticky-sidebar",
  "data-testid": "modal-booking-reverse-journey-v4-sticky-sidebar",
  class: "shrink-0 sticky top-0",
  style: {"width":"350px"}
}
const _hoisted_11 = { class: "p-3 border-b border-gray-lp-3004" }
const _hoisted_12 = { class: "p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Title = _resolveComponent("Title")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Card = _resolveComponent("Card")!
  const _component_SenderSectionV4 = _resolveComponent("SenderSectionV4")!
  const _component_ReceiverSectionV4 = _resolveComponent("ReceiverSectionV4")!
  const _component_BookingSdnBanner = _resolveComponent("BookingSdnBanner")!
  const _component_GoodsPackageV4 = _resolveComponent("GoodsPackageV4")!
  const _component_SupportingDocSectionV4 = _resolveComponent("SupportingDocSectionV4")!
  const _component_ProductCardListV4 = _resolveComponent("ProductCardListV4")!
  const _component_FormCompletionPanel = _resolveComponent("FormCompletionPanel")!
  const _component_TotalTarifSectionV4 = _resolveComponent("TotalTarifSectionV4")!
  const _component_BookingStickyFooterV4 = _resolveComponent("BookingStickyFooterV4")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    ref: "modal-booking-reverse-v4",
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.visible = $event)),
    header: false,
    persistent: "",
    customBody: "p-0 bg-gray-lp-1200",
    showOverflow: "",
    customHeight: "calc(80vh / var(--viewport-scale)) !important",
    contentId: "modal-booking-reverse-journey-v4-parent",
    id: "modal-booking-reverse-journey-v4-parent"
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.$t("Ubah Data Alamat")) + " ", 1),
        _createVNode(_component_Icons, {
          name: "close",
          class: "w-5 cursor-pointer",
          onClick: _cache[1] || (_cache[1] = () => (_ctx.visible = false))
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_ctx.isRtsOrCnx)
            ? (_openBlock(), _createBlock(_component_Card, {
                key: 0,
                rounded: "xl",
                class: "flex flex-col p-3 mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DataWrapper, null, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_4, [
                        _createVNode(_component_Title, {
                          label: _ctx.$t('bookingV4.pos.title'),
                          fontSize: 16,
                          bold: "bold",
                          fontColor: "text-black-lp-100"
                        }, null, 8, ["label"])
                      ]),
                      (!_ctx.isLoadingPartnerField)
                        ? (_openBlock(), _createBlock(_component_SelectSearch, {
                            key: 0,
                            onFocus: _cache[2] || (_cache[2] = (search) => _ctx.filterPartners(search, true)),
                            onFilter: _cache[3] || (_cache[3] = (search) => _ctx.filterPartners(search, true)),
                            isLoading: _ctx.isLoadingPartners,
                            options: _ctx.partnersData,
                            keyName: "name",
                            keyValue: "id",
                            placeholder: _ctx.$t('bookingV4.pos.placeholder'),
                            modelValue: _ctx.selectedPartnerPos,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedPartnerPos = $event)),
                            onChange: _ctx.onChangePartner,
                            class: "mt-2",
                            errorCaption: _ctx.$t('bookingV4.pos.error'),
                            isShowErrorIndicator: 
                !_ctx.selectedPartnerPos?.id && _ctx.currentIndex >= _ctx.partnerIndex
              ,
                            isDisabled: _ctx.disableSelectPartnerField
                          }, null, 8, ["isLoading", "options", "placeholder", "modelValue", "onChange", "errorCaption", "isShowErrorIndicator", "isDisabled"]))
                        : (_openBlock(), _createBlock(_component_Skeleton, {
                            key: 1,
                            height: "30px",
                            class: "mt-2"
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Card, {
            rounded: "xl",
            class: "flex flex-col p-4"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_SenderSectionV4, {
                    modelValue: _ctx.bookingFormV4,
                    "onUpdate:modelValue": _ctx.onSenderUpdate,
                    errors: _ctx.errors,
                    "onUpdate:errors": _cache[5] || (_cache[5] = ($event: any) => (_ctx.errors = $event)),
                    currentIndex: _ctx.currentIndex,
                    "onUpdate:currentIndex": _ctx.onSectionCurrentIndexUpdate,
                    senderCountryIndex: _ctx.senderCountryIndex,
                    senderNameIndex: _ctx.senderNameIndex,
                    senderPhoneIndex: _ctx.senderPhoneIndex,
                    senderAddressIndex: _ctx.senderAddressIndex,
                    configName: _ctx.configRule.senderName,
                    configPhone: _ctx.configRule.senderPhone,
                    configAddress: _ctx.configRule.senderAddress,
                    configDistrict: _ctx.configRule.senderDistrict,
                    class: "mb-2",
                    onAutofillCommodity: _ctx.onAutofillCommodity,
                    onValidationChange: _ctx.onSenderValidationChange
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "currentIndex", "onUpdate:currentIndex", "senderCountryIndex", "senderNameIndex", "senderPhoneIndex", "senderAddressIndex", "configName", "configPhone", "configAddress", "configDistrict", "onAutofillCommodity", "onValidationChange"])
                ]),
                _hoisted_7,
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_ReceiverSectionV4, {
                    ref: "receiverDetail",
                    isDisableReceiver: _ctx.disableReceiver,
                    modelValue: _ctx.bookingFormV4,
                    "onUpdate:modelValue": _ctx.onReceiverUpdate,
                    errors: _ctx.errors,
                    "onUpdate:errors": _cache[6] || (_cache[6] = ($event: any) => (_ctx.errors = $event)),
                    currentIndex: _ctx.currentIndex,
                    "onUpdate:currentIndex": _ctx.onSectionCurrentIndexUpdate,
                    receiverCountryIndex: _ctx.receiverCountryIndex,
                    receiverNameIndex: _ctx.receiverNameIndex,
                    receiverPhoneIndex: _ctx.receiverPhoneIndex,
                    receiverAddressIndex: _ctx.receiverAddressIndex,
                    receiverDistrictIndex: _ctx.receiverDistrictIndex,
                    receiverPostalCodeIndex: _ctx.receiverPostalCodeIndex,
                    isForeign: _ctx.accountIsForeign,
                    isErrorEmbargo: _ctx.isErrorEmbargoDestination,
                    isPostalCodeRequired: !_ctx.isShipment88Lp,
                    isErrorRouteNotFound: _ctx.errorRouteNotFound,
                    "onUpdate:isErrorRouteNotFound": _cache[7] || (_cache[7] = ($event: any) => (_ctx.errorRouteNotFound = $event)),
                    class: "mb-2",
                    onValidationChange: _ctx.onReceiverValidationChange,
                    allowPaste: _ctx.allowPasteReceiverDetail,
                    configName: _ctx.disabledDetailReceiver,
                    configPhone: _ctx.disabledDetailReceiver,
                    configAddress: _ctx.disabledDetailReceiver,
                    configDistrict: _ctx.disabledDetailReceiver,
                    configCountry: _ctx.disabledDetailReceiver,
                    configPostalCode: _ctx.disabledDetailReceiver
                  }, null, 8, ["isDisableReceiver", "modelValue", "onUpdate:modelValue", "errors", "currentIndex", "onUpdate:currentIndex", "receiverCountryIndex", "receiverNameIndex", "receiverPhoneIndex", "receiverAddressIndex", "receiverDistrictIndex", "receiverPostalCodeIndex", "isForeign", "isErrorEmbargo", "isPostalCodeRequired", "isErrorRouteNotFound", "onValidationChange", "allowPaste", "configName", "configPhone", "configAddress", "configDistrict", "configCountry", "configPostalCode"])
                ])
              ]),
              _createVNode(_component_BookingSdnBanner, {
                originDistrict: _ctx.bookingFormV4.sender.originCity,
                destinationDistrict: _ctx.bookingFormV4.receiver.destinationCity,
                active: _ctx.visible && _ctx.sdnReady
              }, null, 8, ["originDistrict", "destinationDistrict", "active"])
            ]),
            _: 1
          }),
          _createVNode(_component_Card, {
            rounded: "xl",
            class: ""
          }, {
            default: _withCtx(() => [
              _createVNode("div", {
                id: "booking-v4-section-goods-pieces",
                class: "p-4",
                onFocusin: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSectionCurrentIndexUpdate(11)))
              }, [
                _createVNode(_component_GoodsPackageV4, {
                  isReverseJourney: "",
                  isItemDetailsRequired: false,
                  showItemDetails: _ctx.showItemDetails,
                  isFtz: _ctx.isFtz,
                  localCurrency: _ctx.formAccountCurrencyCode,
                  currencyPrefix: _ctx.formAccountCurrencyPrefix,
                  numericLocale: _ctx.formAccountCurrencyCode === 'MYR' ? 'my' : 'id',
                  isForeign: _ctx.isForeignAccount,
                  commodityCipl: _ctx.bookingFormV4.commodityCipl,
                  ciplCommodities: _ctx.ciplCommodityOptions,
                  estimatedConversion: _ctx.ciplEstimatedConversion,
                  deminimisThreshold: _ctx.ciplDeminimisThreshold,
                  recipientImportDocRequired: _ctx.recipientImportDocRequired,
                  commodity: _ctx.bookingFormV4.commodity,
                  commodities: _ctx.commoditySearchResults,
                  recommendedCommodities: _ctx.commodityRecommendations,
                  errors: _ctx.errors,
                  loading: _ctx.commodityListLoading,
                  hasMore: _ctx.commodityListHasMore,
                  modalSearchResults: _ctx.modalSearchResults,
                  commodityCategories: _ctx.commodityCategories,
                  commodityCategoryItems: _ctx.commodityCategoryItems,
                  selectedCategoryCode: _ctx.selectedCategoryCode,
                  modalLoading: _ctx.commodityModalLoading,
                  modalLoadingCategory: _ctx.commodityModalLoadingCategory,
                  modalHasMore: _ctx.commodityModalHasMore,
                  isShowSectionUpload: _ctx.isShowSectionUpload,
                  minWeightThreshold: _ctx.sttDetail.sttTotalChargeAbleWeight,
                  showSavePackageCheckbox: false,
                  "onUpdate:commodityCipl": _ctx.onCommodityCiplUpdate,
                  "onUpdate:commodity": _ctx.onCommodityUpdate,
                  onReset: _ctx.onGoodsPackageReset,
                  onCiplValidationChange: _ctx.onCiplValidationChange,
                  onCommodityValidationChange: _ctx.onCommodityValidationChange,
                  onSearchCommodity: _ctx.searchCommodity,
                  onLoadMoreCommodities: _ctx.loadMoreCommodities,
                  onSearchCommodityModal: _ctx.searchCommodityModal,
                  onLoadMoreCommodityModal: _ctx.loadMoreCommodityModal,
                  onSelectCommodityCategory: _ctx.selectCommodityCategory,
                  onCommodityError: _ctx.onCommodityError
                }, null, 8, ["showItemDetails", "isFtz", "localCurrency", "currencyPrefix", "numericLocale", "isForeign", "commodityCipl", "ciplCommodities", "estimatedConversion", "deminimisThreshold", "recipientImportDocRequired", "commodity", "commodities", "recommendedCommodities", "errors", "loading", "hasMore", "modalSearchResults", "commodityCategories", "commodityCategoryItems", "selectedCategoryCode", "modalLoading", "modalLoadingCategory", "modalHasMore", "isShowSectionUpload", "minWeightThreshold", "onUpdate:commodityCipl", "onUpdate:commodity", "onReset", "onCiplValidationChange", "onCommodityValidationChange", "onSearchCommodity", "onLoadMoreCommodities", "onSearchCommodityModal", "onLoadMoreCommodityModal", "onSelectCommodityCategory", "onCommodityError"])
              ], 32)
            ]),
            _: 1
          }),
          (_ctx.showItemDetails)
            ? (_openBlock(), _createBlock(_component_SupportingDocSectionV4, {
                key: 1,
                modelValue: _ctx.bookingFormV4.supportingDoc,
                isFtz: _ctx.isFtz,
                isCipl: _ctx.isCipl,
                fieldRules: _ctx.supportingDocFieldRules,
                showRequiredImageErrors: _ctx.hasAttemptedSubmit,
                errors: _ctx.errors,
                "onUpdate:modelValue": _ctx.onSupportingDocUpdate,
                onValidationChange: _ctx.onSupportingDocValidationChange,
                onFocusin: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSectionCurrentIndexUpdate(20))),
                isReverseJourney: ""
              }, null, 8, ["modelValue", "isFtz", "isCipl", "fieldRules", "showRequiredImageErrors", "errors", "onUpdate:modelValue", "onValidationChange"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Card, {
            rounded: "xl",
            class: ""
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_ProductCardListV4, {
                  modelValue: _ctx.bookingFormV4.product.productType,
                  "onUpdate:modelValue": [
                    _cache[10] || (_cache[10] = ($event: any) => (_ctx.bookingFormV4.product.productType = $event)),
                    _ctx.onProductTypeSelect
                  ],
                  products: _ctx.productCardItems,
                  showAgentDiscountToggle: false,
                  agentDiscountRevealed: false,
                  agentDiscountToggleEnabled: false,
                  hideDiscount: true,
                  loading: _ctx.productUpsellingLoading,
                  isError: _ctx.productUpsellingIsError,
                  currencyPrefix: _ctx.formAccountCurrencyPrefix,
                  configProductType: _ctx.configRule.productType,
                  configTariff: _ctx.configRule.tariff,
                  isClient: _ctx.isTariffMaksed,
                  onRetry: _ctx.onProductUpsellingRetry
                }, null, 8, ["modelValue", "products", "loading", "isError", "currencyPrefix", "configProductType", "configTariff", "isClient", "onUpdate:modelValue", "onRetry"])
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode("aside", _hoisted_10, [
          _createVNode(_component_Card, {
            rounded: "xl",
            class: "flex flex-col gap-y-2 items-stretch"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_FormCompletionPanel, {
                  items: _ctx.formCompletionItems,
                  onNavigate: _ctx.onFormCompletionNavigate
                }, null, 8, ["items", "onNavigate"])
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_BookingStickyFooterV4, { isReverseJourney: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TotalTarifSectionV4, {
                      estimationPrice: _ctx.bookingFormV4.estimationPrice,
                      currencyPrefix: _ctx.formAccountCurrencyPrefix,
                      paymentMethod: _ctx.bookingFormV4.paymentMethod,
                      appliedVoucherCode: _ctx.bookingFormV4.voucher.appliedVoucherCode,
                      itemPrice: _ctx.bookingFormV4.protectionPacking.itemPrice,
                      woodpacking: _ctx.bookingFormV4.protectionPacking.woodpacking,
                      protectionChecked: 
                  _ctx.bookingFormV4.protectionPacking.protectionChecked
                ,
                      isFtz: _ctx.isFtz,
                      isLoading: _ctx.estimationLoading,
                      isError: _ctx.estimationIsError,
                      canOpenDetail: !_ctx.isTariffMaksed,
                      isPriceMasked: _ctx.isTariffMaksed,
                      onRefresh: _ctx.onTariffRefresh,
                      isRetail: !_ctx.isClient,
                      isReverseJourney: "",
                      hideCodReturnFee: ""
                    }, null, 8, ["estimationPrice", "currencyPrefix", "paymentMethod", "appliedVoucherCode", "itemPrice", "woodpacking", "protectionChecked", "isFtz", "isLoading", "isError", "canOpenDetail", "isPriceMasked", "onRefresh", "isRetail"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_LpButton, {
                  class: "mt-4",
                  title: _ctx.$t('bookingV4.footer.save'),
                  color: "red-lp-2400",
                  textColor: "white",
                  isWidthFull: "",
                  fontWeight: "semibold",
                  "data-testid": "booking-v4-submit",
                  tabAccessible: "",
                  onClick: _ctx.onSave
                }, null, 8, ["title", "onClick"])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}